import { Obstacle } from './Obstacle';
import { Diamond } from './Diamond';

export function spawnObstacle(config, sprites) {
  const typeRand = Math.random();
  let type = 'TREE';

  if (typeRand < config.lightningChance) {
    type = 'LIGHTNING';
  } else if (typeRand < 0.5) {
    type = 'CLOUD';
  } else if (typeRand < 0.7) {
    type = 'WALL';
  }

  const height = type === 'CLOUD' ? 70 : type === 'LIGHTNING' ? 100 : 120;
  const y = type === 'CLOUD'
    ? Math.random() * 150 + 40
    : Math.random() * (450 - height - 50) + 50;

  return new Obstacle({
    x: 800, // Start just off the right edge of the 800px canvas
    y,
    width: type === 'CLOUD' ? 90 : 80,
    height,
    speed: config.speed,
    type,
    sprite: sprites && sprites[type] ? sprites[type] : null
  });
}

export function spawnDiamond() {
  return new Diamond(820, Math.random() * 400 + 50);
}

